import {
    GET_PAYMENT_DETAIL,
    GET_PAYMENT_DETAIL_SUCCESS,
    GET_PAYMENT_DETAIL_FAIL,
} from "./actionTypes"

const INIT_STATE = {
    paymentDetails: {
        list: [],
        countList: 0,
    },
    types: [],
    error: "",
    loading: false,
    loadingSave: false,
    response: null,
}

const paymentDetails = (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_PAYMENT_DETAIL:
            return {
                ...state,
                paymentDetails: {},
                loading: true
            }
        case GET_PAYMENT_DETAIL_SUCCESS:
            return {
                ...state,
                paymentDetails: action.payload.data,
                loading: false
            }

        case GET_PAYMENT_DETAIL_FAIL:

            return {
                ...state,
                error: action.payload,
                loading: false
            }

        default:
            return state
    }
}

export default paymentDetails

